import { Button } from "@/components/ui/button";
import MissingAOIGraphic from "@/assets/study-assets/missing-aoi-graphic.png";

/* Prop Types */
interface ValidationModalProps {
  assetsWithoutRegions: { name: string; index: number }[];
  onClose: () => void;
  onGoToAsset: (index: number) => void;
  studyType: "asset" | "scene";
}

/*
 * ValidationModal component
 * This component is shown when the user tries to proceed to the next step but some assets/scenes don't have regions
 */
export const ValidationModal = ({ assetsWithoutRegions, onClose, onGoToAsset, studyType }: ValidationModalProps) => {
  /* Handlers */
  const handleAddAOI = () => {
    // Take the user to the first asset without regions
    const assetIndex = assetsWithoutRegions[0].index;
    onGoToAsset(assetIndex);
    onClose();
  };

  /* Render */
  const itemTypePlural = studyType === "scene" ? "scenes" : "assets";

  return (
    <div className="flex flex-col justify-center items-center gap-4 p-2">
      <img src={MissingAOIGraphic} alt="Missing AOI Graphic" className="size-36" />

      <h2 className="font-semibold">Some {itemTypePlural} have no AOI elements</h2>

      <p className="text-base-content/70">Please add at least one or more AOI element to:</p>

      <div className="text-base-content/70">
        {assetsWithoutRegions.map(({ name, index }) => (
          <div key={index} className="flex items-center justify-center rounded-lg">
            <p>{name}</p>
          </div>
        ))}
      </div>

      <Button variant="primary" onClick={handleAddAOI}>
        Add missing AOIs
      </Button>
    </div>
  );
};
